import { render, staticRenderFns } from "./TotalLine.vue?vue&type=template&id=b878c8c4&scoped=true"
import script from "./TotalLine.vue?vue&type=script&lang=js"
export * from "./TotalLine.vue?vue&type=script&lang=js"
import style0 from "./TotalLine.vue?vue&type=style&index=0&id=b878c8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b878c8c4",
  null
  
)

export default component.exports